// extracted by mini-css-extract-plugin
export default {"breadcrumbsWrapper":"aFboOn","headerGap":"bFboOn","breadcrumbsGap":"cFboOn","titleGap":"dFboOn","bottomAdditionalContentGap":"eFboOn"};